var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.17 18.85A4 4 0 0 1 10 16h4a4 4 0 0 1 3.83 2.85M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0m6-2a3 3 0 1 0 6 0 3 3 0 0 0-6 0"
})));
export default SvgUserCircle;